import { useEffect, useState } from "react";
import { SWITCHER_WIDTH } from "../../../../../app/src/Utils/Constants";

const useIsMobileViewport = () => {
  const [isMobileViewport, setIsMobileViewport] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth <= SWITCHER_WIDTH;
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const handleResize = () => {
      setIsMobileViewport(window.innerWidth <= SWITCHER_WIDTH);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobileViewport;
};

export default useIsMobileViewport;
